import { render, staticRenderFns } from "./HelpAbout.vue?vue&type=template&id=00abca8e&scoped=true"
import script from "./HelpAbout.vue?vue&type=script&lang=ts"
export * from "./HelpAbout.vue?vue&type=script&lang=ts"
import style0 from "./HelpAbout.vue?vue&type=style&index=0&id=00abca8e&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00abca8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00abca8e')) {
      api.createRecord('00abca8e', component.options)
    } else {
      api.reload('00abca8e', component.options)
    }
    module.hot.accept("./HelpAbout.vue?vue&type=template&id=00abca8e&scoped=true", function () {
      api.rerender('00abca8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Help/HelpAbout.vue"
export default component.exports